import React, { useState, useEffect } from 'react';
import api from '../services/api';

const Logs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    administrador_id: '',
    fue_exitoso: '',
  });
  const [administradores, setAdministradores] = useState([]);

  useEffect(() => {
    fetchLogs();
    fetchAdministradores();
  }, [filters]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.administrador_id)
        params.administrador_id = filters.administrador_id;
      if (filters.fue_exitoso !== '')
        params.fue_exitoso = filters.fue_exitoso === 'true';
      params.limit = 200;

      const response = await api.get('/logs/accesos', { params });
      setLogs(response.data);
    } catch (error) {
      console.error('Error fetching logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAdministradores = async () => {
    try {
      const response = await api.get('/administradores');
      setAdministradores(response.data);
    } catch (error) {
      console.error('Error fetching administradores:', error);
    }
  };

  const resetFilters = () => {
    setFilters({
      administrador_id: '',
      fue_exitoso: '',
    });
  };

  const getStatusBadge = (fue_exitoso) => {
    if (fue_exitoso) {
      return (
        <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-500/20 text-green-300 border border-green-500/30">
          Exitoso
        </span>
      );
    }
    return (
      <span className="px-2 py-1 text-xs font-semibold rounded-full bg-red-500/20 text-red-300 border border-red-500/30">
        Fallido
      </span>
    );
  };

  return (
    <div className="animate-fadeInUp">
      <h2 className="text-2xl font-bold text-white mb-6">Logs de Acceso</h2>

      {/* Filters */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-xl p-6 mb-6 border border-white/20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <select
            value={filters.administrador_id}
            onChange={(e) =>
              setFilters({ ...filters, administrador_id: e.target.value })
            }
            className="w-full px-4 py-2 bg-white/20 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent transition-all duration-300"
          >
            <option value="" className="bg-gray-800">
              Todos los administradores
            </option>
            {administradores.map((admin) => (
              <option key={admin.id} value={admin.id} className="bg-gray-800">
                {admin.nombre_completo || admin.username}
              </option>
            ))}
          </select>

          <select
            value={filters.fue_exitoso}
            onChange={(e) =>
              setFilters({ ...filters, fue_exitoso: e.target.value })
            }
            className="w-full px-4 py-2 bg-white/20 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent transition-all duration-300"
          >
            <option value="" className="bg-gray-800">
              Todos los estados
            </option>
            <option value="true" className="bg-gray-800">
              Exitosos
            </option>
            <option value="false" className="bg-gray-800">
              Fallidos
            </option>
          </select>

          <button
            onClick={resetFilters}
            className="px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-xl transition-all duration-300 border border-white/20"
          >
            Limpiar filtros
          </button>
        </div>
      </div>

      {/* Logs Table */}
      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400"></div>
        </div>
      ) : (
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-xl overflow-hidden border border-white/20">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-white/20">
              <thead className="bg-white/5">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-blue-200 uppercase tracking-wider">
                    Fecha
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-blue-200 uppercase tracking-wider">
                    Usuario
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-blue-200 uppercase tracking-wider">
                    IP Address
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-blue-200 uppercase tracking-wider">
                    Estado
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-blue-200 uppercase tracking-wider">
                    User Agent
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10">
                {logs.map((log) => (
                  <tr
                    key={log.id}
                    className="hover:bg-white/5 transition-colors"
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-200">
                      {new Date(log.fecha_intento).toLocaleString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-white">
                        {log.username}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-blue-200 font-mono">
                        {log.ip_address || '-'}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getStatusBadge(log.fue_exitoso)}
                    </td>
                    <td className="px-6 py-4">
                      <div
                        className="text-xs text-blue-200/60 max-w-md truncate"
                        title={log.user_agent}
                      >
                        {log.user_agent || '-'}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {logs.length === 0 && (
            <div className="text-center py-12">
              <p className="text-blue-200/60">
                No hay registros de acceso para mostrar
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Logs;
